import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="expense";
export function selectAll(parameter){
  console.log("params:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function selectAllApply(parameter){
  console.log("params:",parameter)
  return axios({
    url: `/ws/${moduleName}/selectAllApply`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function selectYearStatistics(parameter){
  console.log("params:",parameter)
  return axios({
    url: `/ws/${moduleName}/selectYearStatistics`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function queryExpenseStatistics(parameter){
  console.log("params:",parameter)
  return axios({
    url: `/ws/${moduleName}/queryExpenseStatistics`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function selectExpenseStatistics(parameter){
  console.log("params:",parameter)
  return axios({
    url: `/ws/${moduleName}/selectExpenseStatistics`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function getLoginUserExpenseOrderInfo(){

  return axios({
    url: `/ws/${moduleName}/getLoginUserExpenseOrderInfo`,
    method: 'get',

  })
}

export function selectExpenseStatisticsByType(parameter){
  console.log("params:",parameter)
  return axios({
    url: `/ws/${moduleName}/selectExpenseStatisticsByType`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function getExpenseStatisticsDetail(parameter){
  console.log("params:",parameter)
  return axios({
    url: `/ws/${moduleName}/getExpenseStatisticsDetail`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}


export function selectRunAll(parameter){
  console.log("params:",parameter)
  return axios({
    url: `/ws/${moduleName}/selectRunAll`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function selectOne(parameter){
  console.log("id:",parameter)
  return axios({
    url: `/ws/${moduleName}/${parameter}`,
    method: 'get'
  })
}

export function selectExpenseCost(businessType,businessId,parameter){
  console.log("businessType:",businessType)
  return axios({
    url: `/ws/${moduleName}/selectExpenseCost/${businessType}/${businessId}`,
    method: 'get',
    params:parameter
  })
}

export function selectBindableBusiness(businessType, parameter){
  return axios({
    url: `/ws/${moduleName}/selectBindableBusiness/${businessType}`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function getUserExpenseStatistics( ){
  return axios({
    url: `/ws/${moduleName}/getUserExpenseStatistics`,
    method: 'get'
  })
}


export function cancelExpense(parameter,data){
  console.log("id:",parameter)
  return axios({
    url: `/ws/${moduleName}/cancelExpense/${parameter}`,
    method: 'put',
    data:data
  })
}


export function insert(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'post',
    data:parameter
  })
}

export function update(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'put',
    data:parameter
  })
}

export function updateHotelDetailFile(detailId,fileInfoVo){
  console.log("data:",fileInfoVo)
  return axios({
    url: `/ws/${moduleName}/updateHotelDetailFile/${detailId}`,
    method: 'put',
    data:fileInfoVo
  })
}
export function updateDetailFile(detailId,fileInfoVo){
  console.log("data:",fileInfoVo)
  return axios({
    url: `/ws/${moduleName}/updateDetailFile/${detailId}`,
    method: 'put',
    data:fileInfoVo
  })
}

export function updateDetailType(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}/updateDetailType`,
    method: 'put',
    data:parameter
  })
}

export function eliminateDetail(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}/eliminateDetail`,
    method: 'put',
    data:parameter
  })
}


export function eliminateHotelDetail(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}/eliminateHotelDetail`,
    method: 'put',
    data:parameter
  })
}

export function revokeApply(id,version){
  console.log("data:",id,version)
  return axios({
    url: `/ws/${moduleName}/revokeApply/${id}/${version}`,
    method: 'put'
  })
}


export function deleteObj(ids){
  console.log("ids",ids)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'delete',
    params:ids,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export default {
  selectOne,
  selectAllApply,
  queryExpenseStatistics,
  selectYearStatistics,
  selectAll,
  cancelExpense,
  selectRunAll,
  revokeApply,
  updateDetailType,
  eliminateDetail,
  update,
  selectExpenseStatistics,
  getLoginUserExpenseOrderInfo,
  save:insert,
  selectExpenseStatisticsByType,
  getExpenseStatisticsDetail,
  delete:deleteObj,
  selectExpenseCost,
  selectBindableBusiness,
  getUserExpenseStatistics,
  updateHotelDetailFile,
  updateDetailFile,
  eliminateHotelDetail
}
